import { buildError } from '../../error-reporting/builders/buildError';
import { REQUEST_TIMEOUT } from '../constants/statusCodes';
export function buildRequestTimeoutError(message, ...errorProps) {
  return buildError(message, ...errorProps, {
    statusCode: REQUEST_TIMEOUT
  });
}